import { useEffect } from 'react'
import { useRouter } from '@tanstack/react-router'
import { useMsalAuthStore } from '@stores/useMsalAuthStore'

export function RouterAuthSync() {
    const router = useRouter()

    useEffect(() => {
        const invalidate = () => router.invalidate()

        const unsubMsal = useMsalAuthStore.subscribe((s) => s.status, invalidate)

        return () => {
            unsubMsal()
        }
    }, [router])

    return null
}
